// @flow
import axios from 'lib/defaultClient';
import queryString from 'query-string';

export type WriteLetterPayload = {
  title: string,
  body: string,
  is_temp: boolean,
  tags: Array<string>,
  categories: Array<string>,
  thumbnail: ?string,
  url_slug?: ?string,
  is_private: boolean,
  series_id: ?string,
};

export const writeLetter = (payload: WriteLetterPayload) => axios.post('/letters', payload);

export type UpdateLetterPayload = {
  id: string,
  title: string,
  body: string,
  tags: Array<string>,
  categories: Array<string>,
  url_slug?: ?string,
  thumbnail?: string,
  is_temp: boolean,
  thumbnail: ?string,
  is_private: boolean,
  series_id: ?string,
};

export const updateLetter = ({ id, ...payload }: UpdateLetterPayload) =>
  axios.patch(`/letters/${id}`, payload);

export type ReadLetterPayload = {
  username: string,
  urlSlug: string,
};

export const readLetter = ({ username, urlSlug }: ReadLetterPayload) =>
  axios.get(`/letters/@${username}/${urlSlug}`);

export type UploadImagePayload = {
  file: any,
  letterId: string,
  onUploadProgress(): void,
};

export const uploadImage = ({ file, letterId, onUploadProgress }: UploadImagePayload) => {
  const data = new FormData();
  data.append('letter_id', letterId);
  data.append('image', file);
  return axios.post('/files/upload/letter', data, {
    onUploadProgress,
  });
};

export type TempSavePayload = {
  title: string,
  body: string,
  letterId: string,
};

export const tempSave = ({ letterId, title, body }: TempSavePayload) =>
  axios.post(`/letters/${letterId}/saves`, { title, body });

export type CreateUploadUrlPayload = { letterId: string, filename: string };
export const createUploadUrl = ({ letterId, filename }: CreateUploadUrlPayload) => {
  return axios.post('/files/create-url/letter-image', { letter_id: letterId, filename });
};

/* LISTING RELATED... */
export const getPublicLetters = (cursor: ?string, category: ?string, sort: ?string) => {
  return axios.get('/letters/public', {
    params: {
      cursor,
      category,
      sort,
    },
  });
};

export const getTrendingLetters = (offset: ?number) => {
  const query = offset ? `?offset=${offset}` : '';
  return axios.get(`/letters/trending${query}`);
};

export type GetUserLettersPayload = {
  username: string,
  tag?: string,
  cursor?: string,
};

export const getUserLetters = ({ username, cursor, tag }: GetUserLettersPayload) => {
  const query = queryString.stringify({
    cursor,
    tag,
  });
  return axios.get(`/letters/@${username}?${query}`);
};

export type GetPublicLettersByCategoryPayload = {
  category: string,
  cursor?: string,
  sort?: string,
};

export const getPublicLettersByCategory = (payload: GetPublicLettersByCategoryPayload) => {
  const query = queryString.stringify(payload);
  return axios.get(`/letters/public?${query}`);
};

export type GetPublicLettersByTagPayload = {
  tag: string,
  cursor?: string,
};

export const getPublicLettersByTag = (payload: GetPublicLettersByTagPayload) => {
  const query = queryString.stringify(payload);
  return axios.get(`/letters/public?${query}`);
};

export type GetTempLettersPayload = {
  username: string,
  cursor?: string,
};

export const getTempLetters = ({ username, cursor }: GetTempLettersPayload) => {
  const query = queryString.stringify({
    is_temp: true,
    cursor,
  });
  return axios.get(`/letters/@${username}?${query}`);
};

export const deleteLetter = (letterId: string) => {
  return axios.delete(`/letters/${letterId}`);
};

export const getLetterById = (letterId: string) => {
  return axios.get(`/letters/${letterId}`);
};

export const getLetterSequences = (letterId: string) => {
  return axios.get(`/letters/sequences?letter_id=${letterId}`);
};



// WEBPACK FOOTER //
// ./src/lib/api/letters/index.js